import type { AssetsSymbols } from '@/shared/types';
import { useDictionary } from './useDictionary';

const useAssetsSymbolsDictionary = () => {
  const { data, isLoading, error, isError } = useDictionary<AssetsSymbols>({
    dictionaryName: 'assetSymbols',
  });

  return {
    assetsSymbolsData: data,
    isAssetsSymbolsLoading: isLoading,
    assetsSymbolsError: error,
    isAssetsSymbolsError: isError,
  };
};

export { useAssetsSymbolsDictionary };
